<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container">
        <div class="row">
          <div class="col-lg-12">
            <h1>Estatísticas</h1>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-graduation-cap" /> Assistentes ativas</div>
                    <h2>{{ stats.assistants_count }}</h2>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-user" /> Clientes ativos</div>
                    <h2>{{ stats.clients_count }}</h2>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-briefcase" /> Projetos ativos</div>
                    <h2>{{ stats.projects_count }}</h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-file-alt" /> Propostas ativas</div>
                    <h2>{{ stats.proposals_count }}</h2>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-handshake" /> Contratações</div>
                    <h2>{{ stats.hires_count }}</h2>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <div>
                    <div><i class="fa-solid fa-star" /> Feedbacks</div>
                    <h2>{{ stats.reviews_count }}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-12">
            <h1>Relatórios</h1>

            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allAssistants()">
                    Lista de assistentes
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allClients()">
                    Lista de clientes
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allProjects()">
                    Lista de projetos
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allReleasedContacts()">
                    Lista de propostas aceitas
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allHires()">
                    Lista de contratações
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="allReviews()">
                    Lista de feedbacks
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-12">
            <h1>Tarefas</h1>

            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="syncSubscriptions()">
                    Sincronizar assinaturas
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="syncCourses()">
                    Sincronizar cursos
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="syncNFs()">
                    Sincronizar NFs
                  </button>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="syncHires()">
                    Sincronizar contratações
                  </button>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="stati">
                  <button class="btn btn-small" @click="syncStreaming()">
                    Sincronizar streaming
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AdminManager from "../../../js/services/admin.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

export default {
  components: { SideBar, TopBar },

  created() {
    this.$store.commit("setActiveSection", "DashboardPage");
    this.$store.commit("setActiveProjectList", null);
    this.loadAdminData();
  },

  data() {
    return {
      profile: null,
      stats: null,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },

  methods: {
    async loadAdminData() {
      this.$store.commit("setLoading", true);

      try {
        let adminData = await AdminManager.getAdminData();
        this.profile = adminData.profile;

        if (!this.profile) {
          window.location = "/cadastro";
        } else {
          this.stats = adminData.stats;
          this.$store.commit("setActiveUser", this.profile);
          this.$store.commit("setLoading", false);
        }
      } catch (error) {
        this.handleAPIError(error, null);
      }
    },

    allAssistants() {
      let url = `${Config.apiHost}/admin/reports/assistants`;
      window.open(url);
    },

    allClients() {
      let url = `${Config.apiHost}/admin/reports/clients`;
      window.open(url);
    },

    allProjects() {
      let url = `${Config.apiHost}/admin/reports/projects`;
      window.open(url);
    },

    allReleasedContacts() {
      let url = `${Config.apiHost}/admin/reports/accepted-proposals`;
      window.open(url);
    },

    allHires() {
      let url = `${Config.apiHost}/admin/reports/hires`;
      window.open(url);
    },

    allReviews() {
      let url = `${Config.apiHost}/admin/reports/reviews`;
      window.open(url);
    },

    syncSubscriptions() {
      AdminManager.syncSubscriptions();
    },

    syncCourses() {
      AdminManager.syncCourses();
    },

    syncNFs() {
      let url = `${Config.apiHost}/admin/sync-nfs`;
      window.open(url);
    },

    syncHires() {
      let url = `${Config.apiHost}/admin/sync-hires`;
      window.open(url);
    },

    syncStreaming() {
      let url = `${Config.apiHost}/admin/sync-streaming`;
      window.open(url);
    },
  },
};
</script>
